<template>
  <div>
    <el-row :gutter="15" class="wrapper">
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待处理订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { todo: true } }">
                <p class="value">{{ data.orders_todo_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">草稿订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['init'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_init_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待提交辅料订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { order_accessory_deliveries_state_eq: 'pending', creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_accessory_state_pending_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待销售主管审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['wait_sales_director_audit'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_wait_sales_director_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待跟单员审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['pending'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_pending_count}}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">已拒绝订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['rejected', 'sales_director_rejected', 'boss_rejected', 'supplier_boss_rejected', 'supplier_rejected'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_rejected_count}}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待总管理员审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { state_in: ['wait_admin_audit'] } }">
                <p class="value">{{ data.orders_wait_admin_audit_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待老板审核订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['wait_boss_audit'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_wait_boss_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待供应商BOSS确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_boss_confirm'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_wait_supplier_boss_confirm_count}}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待供应商员工确认订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { state_in: ['wait_supplier_confirm'], creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_wait_supplier_confirm_count}}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">送货中订单数</p>
          <div class="content">
            <div class="item">
              <bean-link :to="{ name: 'orders.index', query: { deliveries_state_eq: 'delivering', creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_delivery_delivering_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">被拒收辅料订单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'orders.index', query: { order_accessory_deliveries_state_eq: 'rejected', creator_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.orders_accessory_state_rejected_count || 0 }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">待销售主管审核制单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'product_designs.index', query: { state_in: ['wait_sales_director_audit'], designer_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.product_designs_wait_sales_director_audit_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :md="6">
        <div class="card section">
          <p class="page-title">已拒绝制单数</p>
          <div class="content">
            <div class="item">
              <bean-link
                :to="{ name: 'product_designs.index', query: { state_in: ['sales_director_rejected', 'rejected'], designer_id_eq: $root.user.user_id } }">
                <p class="value">{{ data.product_designs_rejected_count }}</p>
              </bean-link>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class SalesmanHome extends Vue {
  data = {
    orders_todo_count: 0,
    orders_init_count: 0,
    orders_wait_sales_director_audit_count: 0,
    orders_pending_count: 0,
    orders_wait_boss_audit_count: 0,
    orders_wait_supplier_boss_confirm_count: 0,
    orders_wait_supplier_confirm_count: 0,
    orders_rejected_count: 0,
    product_designs_wait_sales_director_audit_count: 0,
    product_designs_rejected_count: 0
  };

  async mounted() {
    this.data = await this.$request.get('/dashboard/salesman_role')
  }
}
</script>
